import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { FULL_URL } from '../../../config/Master';
import { getPatternModal } from '../../../style';
import breakpoints from 'theme/material/breakpoints';

const CenterDashDiv = styled('div')({
  textAlign: 'center',
  borderTop: '1px dashed #C9C9C9',
  padding: 20,
  paddingBottom: 0,
  width: 'calc(100% - 40px)',
  [breakpoints.down(639.05)]: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 0,
    gap: 10,
  },
  [breakpoints.down(479.05)]: {
    marginTop: 0,
  },
});

const StyledLink = styled('a')(() => ({
  textDecoration: 'underline',
  fontSize: 14,
  lineHeight: '19px',
  letterSpacing: -0.3,
  color: getPatternModal().linkBlue,
  [breakpoints.down(639.05)]: {
    fontSize: 13,
    lineHeight: '17px',
    letterSpacing: 'normal',
  },
}));

const StyledSeparator = styled('span')(() => ({
  display: 'inline-block',
  paddingLeft: 5,
  paddingRight: 5,
  color: getPatternModal().linkBlue,
  [breakpoints.down(639.05)]: {
    display: 'none',
  },
}));

const OfferModalFooter = (): ReactElement => {
  return (
    <CenterDashDiv>
      <StyledLink href={`${FULL_URL}/blog/tips-for-dating-safely-during-covid-and-after`} target="_blank">
        Read Safe Dating Tips
      </StyledLink>
      <StyledSeparator>|</StyledSeparator>
      <StyledLink href={`${FULL_URL}/community-guidelines`} target="_blank">
        Read Community Guidelines
      </StyledLink>
    </CenterDashDiv>
  );
};

export default OfferModalFooter;
